
import { mapState } from "vuex";
import CurrencyConverter from "../common/currency-converter.vue";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog, CurrencyConverter },
  props: {
    dialog: Boolean,
    comboItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      valid: false,
      searchQuery: "",
      localSelectedItems: [],
      itemQuantities: {},
      localSelectedVariants: {},
      selectRule: [(v) => !!v || "Please select a variant"]
    };
  },
  computed: {
    ...mapState("menu", ["menuItems"]),

    filteredItems() {
      if (!this.searchQuery) {
        return this.menuItems;
      }
      const query = this.searchQuery.toLowerCase();
      return this.menuItems.filter((item) =>
        item.item_name.toLowerCase().includes(query)
      );
    }
  },

  beforeMount() {
    this.initializeComboItems();
  },
  methods: {
    handleItemSelection(item) {
      if (this.localSelectedItems.includes(item.id) && this.hasVariants(item)) {
        const defaultVariant = this.sortedVariants(item.variants.items)[0];
        this.$set(this.localSelectedVariants, item.id, defaultVariant.id);
      }
    },
    sortedVariants(variants) {
      return [...variants].sort((a, b) => a.price - b.price);
    },
    hasVariants(item) {
      return (
        item.variants && item.variants.items && item.variants.items.length > 0
      );
    },
    getPrice(item) {
      const selectedVariantId = this.localSelectedVariants[item.id];

      if (selectedVariantId) {
        const selectedVariant = item.variants.items.find(
          (variant) => variant.id === selectedVariantId
        );

        if (selectedVariant) {
          return selectedVariant.price;
        }
      }

      // If no variant is selected, return the item's base price or the least price variant
      let price = item.item_price;

      if (
        item.variants &&
        item.variants.items &&
        item.variants.items.length > 0
      ) {
        const variantWithLeastPrice = item.variants.items.reduce(
          (min, variant) => (variant.price < min.price ? variant : min)
        );
        price = variantWithLeastPrice.price;
      }
      return price;
    },

    getItemQuantity(itemId) {
      return this.itemQuantities[itemId] || 1;
    },

    updateQty(index, increment) {
      const item = this.filteredItems[index];
      if (!item) return;

      const currentQty = this.getItemQuantity(item.id);
      const newQty = increment ? currentQty + 1 : currentQty - 1;

      if (newQty >= 1 && newQty <= 15) {
        this.$set(this.itemQuantities, item.id, newQty);
      }
    },
    handleVariantChange(item, selectedVariant) {
      this.$set(this.localSelectedVariants, item.id, selectedVariant);
    },

    highlightedText(text) {
      if (!this.searchQuery) return text;
      const query = this.searchQuery.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const regex = new RegExp(`(${query})`, "gi");
      return text.replace(regex, `<span style="color: orange">$1</span>`);
    },
    initializeComboItems() {
      if (this.comboItems && this.comboItems.length > 0) {
        this.comboItems.forEach((item) => {
          const itemId = item.comboable_id ? item.comboable_id : item.id;
          this.localSelectedItems.push(itemId);
          this.$set(this.itemQuantities, itemId, item.quantity || 1);
          const defaultVariant =
            item.selectedVariant ||
            (item?.variants?.items
              ? this.sortedVariants(item.variants.items)[0]
              : null);
          if (defaultVariant) {
            this.$set(
              this.localSelectedVariants,
              itemId,
              defaultVariant?.id || defaultVariant
            );
          }
        });
      } else {
        if (this.filteredItems && this.filteredItems.length > 0) {
          this.filteredItems.forEach((item) => {
            this.$set(
              this.localSelectedVariants,
              item.id,
              this.sortedVariants(item.variants.items)[0]?.id ||
                this.sortedVariants(item.variants.items)[0]
            );
          });
        }
      }
    },
    submitSelection() {
      const selectedItems = this.menuItems
        .filter((item) => this.localSelectedItems.includes(item.id))
        .map((item) => ({
          ...item,
          selectedVariant: this.localSelectedVariants[item.id],
          quantity: this.getItemQuantity(item.id),
          showOptions: false
        }));

      this.$emit("submit-selection", selectedItems);
      this.$emit("close-dialog");
    }
  }
};
